import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { Button, ButtonGroup, FormGroup, FormControl, Glyphicon, Modal, Checkbox } from "react-bootstrap";
import { Event } from "components/Comet";
import Loading from "components/Loading";
import Request from "request";
import WordCloud from "../../../../player/js/cloud";

function PollResultAnswerBar({ poll, answer }) {
    if ('rating' === poll.type) {
        let ratingMax = answer.ratingMax;
        let ratingAvg = answer.count ? answer.ratingSum / answer.count : 0;
        let percent = ratingAvg ? ratingAvg / ratingMax * 100 : 0;

        return (
            <div className="pollResultBar" key={answer.id}>
                <div className="pollResultBarValue">{ratingAvg}</div>
                <div className="pollResultBarLabel">{answer.textRu}</div>
                <div className="pollResultBarFill" style={{ width: `${percent}%` }} />
            </div>
        );
    }

    const answerSum = poll.answer.reduce((s, answer) => s + answer.count, 0);
    const percent = answerSum ? answer.count / answerSum * 100 : 0;

    const value = poll.percentage ? Math.round(percent * 100) / 100 + '%' : answer.count;

    return (
        <div className="pollResultBar" key={answer.id}>
            <div className="pollResultBarValue">{value}</div>
            <div className="pollResultBarLabel">{answer.textRu}</div>
            <div className="pollResultBarFill" style={{ width: `${percent}%` }} />
        </div>
    );
}

function PollBarsResult({ poll }) {
    return (
        <section>
            <h3>{poll.textRu}</h3>
            {poll.answer.sort((a, b) => a.order - b.order).map(answer => <PollResultAnswerBar key={answer.id} poll={poll} answer={answer} />)}
        </section>
    );
}

function PollWordCloudResult({ poll }) {
    const list = poll.answer
        .map(answer => ([answer.textRu, answer.count]))
        ;

    useEffect(() => {

        if (list?.length) {
            WordCloud.cloud(list, {
                colors: poll?.options?.answerColors || [],
            })
        }

        return () => {
            WordCloud.WordCloud.stop();
        }
    }, [poll, list]);

    const containerStyle = {
        width: '100%',
        height: '100%',
        minHeight: '450px',
        position: 'relative',
        backgroundImage: `url(${poll.backgroundImageUrl})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
    };

    return (
        <div id="open-poll-result" style={containerStyle}>
            {/* <div id="open-poll-result" className="open-poll-result" style={containerStyle}> */}
            <canvas id="open-poll-result-canvas" style={{ width: '100%', height: '100%' }}></canvas>
        </div>
    );
}

function PollResultContent({ poll }) {
    if ('open' === poll.type) {
        return (
            <PollWordCloudResult poll={poll} />
        );
    }

    return (
        <PollBarsResult poll={poll} />
    );
}

function PollResult({ event, pollId, onCancel }) {
    const backgroundImageRef = useRef(null);
    const [poll, setPoll] = useState(null);
    const [isLoading, setLoading] = useState(false);
    const [isUpdating, setUpdating] = useState(false);
    const [isFullScreen, setFullScreen] = useState(false);

    useEffect(() => {
        if (!pollId) {
            setPoll(null);

            return;
        }

        if (poll && poll.id === pollId) return;

        setLoading(true);
        Request.get(`/api/cp/event/${event.eventPassword}/poll/${pollId}`)
            .then(poll => {
                setPoll(poll);
                setLoading(false);
            })
            ;
    }, [pollId]);

    function onUpdatePoll(poll) {
        if (!!poll && poll.id !== pollId) return;

        setPoll(prev => ({ ...prev, ...poll }));
    }

    function onUpdatePollAnswer(answer) {
        if (poll.id !== answer.pollId) {
            return;
        }

        const _poll = Object.assign({}, poll);
        const index = _poll.answer.findIndex(a => a.id === answer.id);

        if (index >= 0) {
            _poll.answer[index] = Object.assign({}, _poll.answer[index], answer);
            setPoll(_poll);
        }
    }

    const saveImage = (file) => {
        setUpdating(true);
        const formData = new FormData();
        formData.append('resultPageBackgroundImage', file)
        Request.post(`/api/cp/event/${event.eventPassword}/poll/${poll.id}`, formData)
            .then(poll => setPoll(poll))
            .catch(e => console.error(e))
            .finally(() => setUpdating(false))
    }

    const saveProperty = (key, value) => {
        setUpdating(true);
        Request.post(`/api/cp/event/${event.eventPassword}/poll/${poll.id}`, { [key]: value })
            .then(poll => setPoll(poll))
            .catch(e => console.error(e))
            .finally(() => setUpdating(false))
    }

    const Content = ({ isLoading, poll }) => (isLoading || !poll
        ? <Loading>Загрузка данных опроса</Loading>
        : <PollResultContent poll={poll} />
    );

    const containerStyle = {
        position: 'absolute',
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        zIndex: 1100,
        background: '#FFFFFF',
        padding: 10,
    };

    if (isFullScreen) {
        return (
            <div style={containerStyle} onClick={() => setFullScreen(false)}>
                <Content isLoading={isLoading} poll={poll} />
            </div>
        );
    }

    return (
        <>
            <Modal show={pollId > 0} onHide={onCancel} bsSize="large">
                <Modal.Header closeButton>
                    <Modal.Title style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                        Результаты опроса
                        {(poll && 'open' === poll.type) && <Button
                            bsSize="small"
                            href={`/cp/event/${event.eventPassword}/interactive/managePollResult/${poll.type}/${pollId}`}
                            target="_blank">
                            <Glyphicon glyph="pencil" /> Управлять результатами
                        </Button>}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {poll &&
                        <div>
                            <ButtonGroup>
                                <Button bsSize="small" onClick={() => backgroundImageRef.current?.click()} disabled={isUpdating}><Glyphicon glyph="folder-open" /> {poll.resultPageBackgroundImageUrl ? "Изменить" : "Добавить"} фоновое изображение страницы результата</Button>
                                {poll.resultPageBackgroundImageUrl && <Button bsSize="small" disabled={isUpdating} onClick={() => saveImage('DELETE')} bsStyle="danger"><Glyphicon glyph="trash" /></Button>}
                            </ButtonGroup>

                            {poll.resultPageBackgroundImageUrl && <div><img src={poll.resultPageBackgroundImageUrl} style={{ maxWidth: '100%', maxHeight: 120 }} alt="" /></div>}

                            <FormControl
                                type="file"
                                style={{ display: 'none' }}
                                onChange={(e) => saveImage(e.target.files[0] || null)}
                                inputRef={(ref) => backgroundImageRef.current = ref}
                            />

                            <FormGroup style={{ marginTop: '1rem' }}>
                                <Checkbox
                                    checked={poll.backgroundEnabled}
                                    onChange={e => saveProperty('backgroundEnabled', e.target.checked)}
                                    inline
                                >
                                    Показывать подложку
                                </Checkbox>
                                <Checkbox
                                    checked={poll.headerHidden}
                                    onChange={e => saveProperty('headerHidden', e.target.checked)}
                                    inline
                                >
                                    Скрывать заголовок
                                </Checkbox>
                            </FormGroup>
                        </div>
                    }
                    <Content isLoading={isLoading} poll={poll} />
                    <Event event="update:poll" handler={onUpdatePoll} />
                    <Event event="update:poll/answer" handler={onUpdatePollAnswer} />
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        disabled={isUpdating}
                        href={`/event/${event.eventKey}/watch-only/poll-result/${pollId}`}
                        target="_blank">
                        <Glyphicon glyph="new-window" /> Открыть в новой вкладке
                    </Button>
                    {/* <Button onClick={() => setFullScreen(true)}>Развернуть</Button> */}
                    <Button onClick={onCancel} disabled={isUpdating}>Закрыть</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

const mapStateToProps = (store) => {
    return {
        event: store.currentEvent
    };
};

export default connect(mapStateToProps)(PollResult);